import Vue from "vue";
import Router from "vue-router";

let underDevelopment = false;

Vue.use(Router);
const DefaultContainer = () => import("@/containers/DefaultContainer");
const Page404 = () => import("@/views/Page404");
const Page403 = () => import("@/views/Page403");
const Debug = () => import("@/views/Debug");
const ComingSoon = () => import("@/views/ComingSoon");
const SystemComingSoon = () => import("@/components/ComingSoon");
const Login = () => import("@/views/Login");
const AdminLogin = () => import("@/views/AdminLogin");
const RefLogin = () => import("@/views/RefLogin");
const UniLogin = () => import("@/views/UniLogin");
const CompanyLogin = () => import("@/views/CompanyLogin");
const AcceleratorLogin = () => import("@/views/AcceleratorLogin");
// NOTE login for delveloping cause captcha doesnt work in locak
const LoginSolid = () => import("@/views/LoginSolid");
const AdminLoginSolid = () => import("@/views/AdminLoginSolid");
const RefLoginSolid = () => import("@/views/RefLoginSolid");
const UniLoginSolid = () => import("@/views/UniLoginSolid");
const CompanyLoginSolid = () => import("@/views/CompanyLoginSolid");
const AcceleratorLoginSolid = () => import("@/views/AcceleratorLoginSolid");

const ChangeLog = () => import("@/views/ChangeLog");

// Researcher Pages
// const PAGE = () =>
// import('@/views/researcher/PAGE)
const researcherDashboard = () => import("@/views/researcher/Dashboard");
const guide = () => import("@/views/Guide");
const researcherProfile = () => import("@/views/researcher/Profile");
const researcherNewPc = () => import("@/views/researcher/NewPc");
const researcherGoingPc = () => import("@/views/researcher/GoingPc");
const researcherArchivePc = () => import("@/views/researcher/ArchivePc");
const researcherProposalCp = () => import("@/views/researcher/ProposalCp");
const researcherPhdProposalCp = () =>
  import("@/views/researcher/PhdProposalCp");
const researcherMasterProposalCp = () =>
  import("@/views/researcher/MasterProposalCp");
const researcherOpportunityCp = () =>
  import("@/views/researcher/OpportunityCp");
const researcherMeetingCp = () => import("@/views/researcher/MeetingCp");
const researcherEliteCp = () => import("@/views/researcher/EliteCp");
const researcherPostDocCp = () => import("@/views/researcher/PostDocCp");

const researcherProposals = () => import("@/views/researcher/Proposals");
const researcherActiveProposals = () =>
  import("@/views/researcher/ActiveProposals");
const researcherDeactiveProposals = () =>
  import("@/views/researcher/DeactiveProposals");
const researcherDecidedProposals = () =>
  import("@/views/researcher/DecidedProposals");
const newProposal = () => import("@/views/researcher/NewProposal");
const completeProposal = () => import("@/views/researcher/CompleteProposal");
const viewProposal = () => import("@/views/researcher/Proposal");
const viewPhdProposal = () => import("@/views/researcher/PhdProposal");
const researcherActivePhdThesis = () =>
  import("@/views/researcher/ActivePhdThesis");
const researcherDeactivePhdThesis = () =>
  import("@/views/researcher/DeactivePhdThesis");
const researcherDecidedPhdThesis = () =>
  import("@/views/researcher/DecidedPhdThesis");
const viewMasterProposal = () => import("@/views/researcher/MasterProposal");
const researcherActiveMasterThesis = () =>
  import("@/views/researcher/ActiveMasterThesis");
const researcherDeactiveMasterThesis = () =>
  import("@/views/researcher/DeactiveMasterThesis");
const researcherDecidedMasterThesis = () =>
  import("@/views/researcher/DecidedMasterThesis");
const sampleRepeatable = () => import("@/views/researcher/sampleRepeatable");
const phdThesis = () => import("@/views/researcher/phdThesis");
const NewPhdThesis = () => import("@/views/researcher/NewPhdThesis");
const completePhdThesis = () => import("@/views/researcher/CompletePhdThesis");
const CompleteArticle = () => import("@/views/researcher/CompleteArticle");
const NewArticle = () => import("@/views/researcher/NewArticle");
const ViewArticle = () => import("@/views/researcher/Article");
const ActiveArticle = () => import("@/views/researcher/ActiveArticle");
const DeactiveArticle = () => import("@/views/researcher/DeactiveArticle");
const DecidedArticle = () => import("@/views/researcher/DecidedArticle");
const NewElite = () => import("@/views/researcher/NewElite");
const ViewElite = () => import("@/views/researcher/Elite");
const ActiveElite = () => import("@/views/researcher/ActiveElite");
const DeactiveElite = () => import("@/views/researcher/DeactiveElite");
const DecidedElite = () => import("@/views/researcher/DecidedElite");
const CompleteElite = () => import("@/views/researcher/CompleteElite");
const NewPostDoc = () => import("@/views/researcher/NewPostDoc");
const ActivePostDoc = () => import("@/views/researcher/ActivePostDoc");
const DeactivePostDoc = () => import("@/views/researcher/DeactivePostDoc");
const DecidedPostDoc = () => import("@/views/researcher/DecidedPostDoc");
const CompletePostDoc = () => import("@/views/researcher/CompletePostDoc");
const ViewPostDoc = () => import("@/views/researcher/PostDoc");
const NewMeeting = () => import("@/views/researcher/NewMeeting");
const ViewMeeting = () => import("@/views/researcher/Meeting");
const CompleteMeeting = () => import("@/views/researcher/CompleteMeeting");
const ActiveMeeting = () => import("@/views/researcher/ActiveMeeting");
const DeactiveMeeting = () => import("@/views/researcher/DeactiveMeeting");
const DecidedMeeting = () => import("@/views/researcher/DecidedMeeting");
const NewOpportunity = () => import("@/views/researcher/NewOpportunity");
const ViewOpportunity = () => import("@/views/researcher/Opportunity");
const ActiveOpportunity = () => import("@/views/researcher/ActiveOpportunity");
const DeactiveOpportunity = () =>
  import("@/views/researcher/DeactiveOpportunity");
const DecidedOpportunity = () =>
  import("@/views/researcher/DecidedOpportunity");
const CompleteOpportunity = () =>
  import("@/views/researcher/CompleteOpportunity");
const masterThesis = () => import("@/views/researcher/MasterThesis");
const completeMasterThesis = () =>
  import("@/views/researcher/CompleteMasterThesis");
const newMasterThesis = () => import("@/views/researcher/NewMasterThesis");
const newRequest = () => import("@/views/researcher/newRequest");
const newUniRequestForm = () => import("@/views/researcher/NewUniRequest");
// const newRequestForm = () => import("@/views/researcher/newRequestForm");
const researcherActiveUniRequests = () =>
  import("@/views/researcher/ActiveUniRequest");
const researcherInactiveUniRequests = () =>
  import("@/views/researcher/DeactiveUniRequest");
const researcherUniRequestInfo = () => import("@/views/researcher/UniRequest");
const researcherEditUniRequest = () =>
  import("@/views/researcher/EditUniRequest");

// University Pages
// const PAGE = () =>
// import('@/views/university/PAGE)
const universityDashboard = () => import("@/views/university/Dashboard");
const universityChangePass = () => import("@/views/university/ChangePassword");
const universityProposals = () => import("@/views/university/Proposals");
const universityProposal = () => import("@/views/university/Proposal");
const universityArticles = () => import("@/views/university/Articles");
const universityArticle = () => import("@/views/university/Article");
const universityElites = () => import("@/views/university/Elites");
const universityElite = () => import("@/views/university/Elite");
const universityMasters = () => import("@/views/university/Masters");
const universityMaster = () => import("@/views/university/Master");
const universityMeetings = () => import("@/views/university/Meetings");
const universityMeeting = () => import("@/views/university/Meeting");
const universityOpportunities = () =>
  import("@/views/university/Opportunities");
const universityOpportunity = () => import("@/views/university/Opportunity");
const universityPhds = () => import("@/views/university/Phds");
const universityPhd = () => import("@/views/university/Phd");
const universityPostDocs = () => import("@/views/university/PostDocs");
const universityPostDoc = () => import("@/views/university/PostDoc");
const editUniversityImages = () => import("@/views/Gallery");
const editUniversityFaculty = () => import("@/views/university/Faculty");
const uniPreview = () => import("@/views/university/Preview");
const uniCompleteCat = () => import("@/views/university/CompleteCat");
const uniFaq = () => import("@/views/university/Faq");
// uni requests
const uniNewUniRequest = () => import("@/views/university/NewUniRequest");
const uniCompleteUniRequest = () =>
  import("@/views/university/CompleteUniRequest");
const uniActiveUniRequests = () =>
  import("@/views/university/ActiveUniRequists");
const uniInactiveUniRequests = () =>
  import("@/views/university/InactiveUniRequists");
const uniUniRequest = () => import("@/views/university/UniRequest");

// company Pages
// const PAGE = () =>
// import('@/views/company/PAGE)
const companyDashboard = () => import("@/views/company/Dashboard");
const editCompanyImages = () => import("@/views/Gallery");

// accelerator Pages
const acceleratorDashboard = () => import("@/views/accelerator/Dashboard");
const editAcceleratorImages = () => import("@/views/Gallery");
const RegisteredProposals = () =>
  import("@/views/accelerator/RegisteredProposals");
const RegisteredPhds = () => import("@/views/accelerator/RegisteredPhds");
const RegisteredMasters = () => import("@/views/accelerator/RegisteredMasters");
const RegisteredOpportunity = () =>
  import("@/views/accelerator/RegisteredOpportunity");
const RegisteredPostDoc = () => import("@/views/accelerator/RegisteredPostDoc");
const PcReports = () => import("@/views/accelerator/PcReports");
const AcceleratorDoneProjectsControl = () =>
  import("@/views/accelerator/DoneProjectsControl");
const ProposalPc = () => import("@/views/accelerator/ProposalPc");
const PostDocPc = () => import("@/views/accelerator/PostDocPc");
const MasterProposalPc = () => import("@/views/accelerator/MasterProposalPc");
const PhdProposalPc = () => import("@/views/accelerator/PhdProposalPc");
const ElitePc = () => import("@/views/accelerator/ElitePc");
const MeetingPc = () => import("@/views/accelerator/MeetingPc");
const OpportunityPc = () => import("@/views/accelerator/OpportunityPc");
const AllRequests = () => import("@/views/accelerator/AllRequests");
const WaitingForCommercialization = () =>
  import("@/views/accelerator/WaitingForCommercialization");
const acceleratorReviews = () => import("@/views/accelerator/Reviews");
const acceleratorArchiveReviews = () =>
  import("@/views/accelerator/ArchiveReviews");
const acceleratorProposal = () => import("@/views/accelerator/Proposal");
const acceleratorPhdProposal = () => import("@/views/accelerator/PhdProposal");
const acceleratorMasterProposal = () =>
  import("@/views/accelerator/MasterProposal");
const acceleratorArticle = () => import("@/views/accelerator/Article");
const acceleratorOpportunity = () => import("@/views/accelerator/Opportunity");
const acceleratorMeeting = () => import("@/views/accelerator/Meeting");
const acceleratorPostDoc = () => import("@/views/accelerator/PostDoc");
const acceleratorElite = () => import("@/views/accelerator/Elite");
const ProposalReview = () => import("@/views/accelerator/ProposalReview");
const PhdReview = () => import("@/views/accelerator/PhdReview");
const MasterReview = () => import("@/views/accelerator/MasterReview");
const ArticleReview = () => import("@/views/accelerator/ArticleReview");
const OpportunityReview = () => import("@/views/accelerator/OpportunityReview");
const MeetingReview = () => import("@/views/accelerator/MeetingReview");
const PostDocReview = () => import("@/views/accelerator/PostDocReview");
const EliteReview = () => import("@/views/accelerator/EliteReview");

// Referee Pages
// const PAGE = () =>
// import('@/views/referee/PAGE)
const refereeDashboard = () => import("@/views/referee/Dashboard");
const refereeProfile = () => import("@/views/referee/Profile");
const refereeReviews = () => import("@/views/referee/Reviews");
const refereeArchive = () => import("@/views/referee/Archive");
const refereeReviewArticle = () => import("@/views/referee/ReviewArticle");
const refereeReviewElite = () => import("@/views/referee/ReviewElite");
const refereeReviewMaster = () => import("@/views/referee/ReviewMaster");
const refereeReviewMeeting = () => import("@/views/referee/ReviewMeeting");
const refereeReviewOpportunity = () =>
  import("@/views/referee/ReviewOpportunity");
const refereeReviewPhd = () => import("@/views/referee/ReviewPhd");
const refereeReviewPostDoc = () => import("@/views/referee/ReviewPostDoc");
const refereeReviewProposal = () => import("@/views/referee/ReviewProposal");

const refereeProjectsControl = () => import("@/views/referee/ProjectsControl");
const refereeDoneProjectsControl = () =>
  import("@/views/referee/DoneProjectsControl");

const refereeProposalCp = () => import("@/views/referee/ProposalCp");
const refereePhdProposalCp = () => import("@/views/referee/PhdProposalCp");
const refereeMasterProposalCp = () =>
  import("@/views/referee/MasterProposalCp");
const refereeMeetingCp = () => import("@/views/referee/MeetingCp");
const refereeOpportunityCp = () => import("@/views/referee/OpportunityCp");
const refereeEliteCp = () => import("@/views/referee/EliteCp");
const refereePostDocCp = () => import("@/views/referee/PostDocCp");

// manager Pages
// const PAGE = () =>
// import('@/views/admin-manager/PAGE)
const managerDashboard = () => import("@/views/admin-manager/Dashboard");
const managerChangePassword = () =>
  import("@/views/admin-manager/ChangePassword");

// Proposal
const managerActiveProposals = () =>
  import("@/views/admin-manager/ActiveProposals");
const managerArchiveProposals = () =>
  import("@/views/admin-manager/ArchiveProposals");
const managerDecidedProposals = () =>
  import("@/views/admin-manager/DecidedProposals");
const managerNeedProposals = () =>
  import("@/views/admin-manager/NeedProposals");
const managerProposal = () => import("@/views/admin-manager/Proposal");

// PhD
const managerActivePhds = () => import("@/views/admin-manager/ActivePhds");
const managerArchivePhds = () => import("@/views/admin-manager/ArchivePhds");
const managerDecidedPhds = () => import("@/views/admin-manager/DecidedPhds");
const managerNeedPhds = () => import("@/views/admin-manager/NeedPhds");
const managerPhdProposal = () => import("@/views/admin-manager/PhdProposal");

// Master
const managerActiveMasters = () =>
  import("@/views/admin-manager/ActiveMasterProposals");
const managerArchiveMasters = () =>
  import("@/views/admin-manager/ArchiveMasterProposals");
const managerDecidedMasters = () =>
  import("@/views/admin-manager/DecidedMasterProposals");
const managerNeedMasters = () =>
  import("@/views/admin-manager/NeedMasterProposals");
const managerMasterProposal = () =>
  import("@/views/admin-manager/MasterProposal");

// Article
const managerActiveArticles = () =>
  import("@/views/admin-manager/ActiveArticles");
const managerArchiveArticles = () =>
  import("@/views/admin-manager/ArchiveArticles");
const managerDecidedArticles = () =>
  import("@/views/admin-manager/DecidedArticles");
const managerNeedArticles = () => import("@/views/admin-manager/NeedArticles");
const managerArticle = () => import("@/views/admin-manager/Article");

// Study Abroad Opportunity
const managerActiveOpportunities = () =>
  import("@/views/admin-manager/ActiveOpportunities");
const managerArchiveOpportunities = () =>
  import("@/views/admin-manager/ArchiveOpportunities");
const managerDecidedOpportunities = () =>
  import("@/views/admin-manager/DecidedOpportunities");
const managerNeedOpportunities = () =>
  import("@/views/admin-manager/NeedOpportunities");
const managerOpportunity = () => import("@/views/admin-manager/Opportunity");

// Scientific Meeting Report
const managerActiveMeetings = () =>
  import("@/views/admin-manager/ActiveMeetings");
const managerArchiveMeetings = () =>
  import("@/views/admin-manager/ArchiveMeetings");
const managerDecidedMeetings = () =>
  import("@/views/admin-manager/DecidedMeetings");
const managerNeedMeetings = () => import("@/views/admin-manager/NeedMeetings");
const managerMeeting = () => import("@/views/admin-manager/Meeting");

// PostDoctorate
const managerActivePostDocs = () =>
  import("@/views/admin-manager/ActivePostDocs");
const managerArchivePostDocs = () =>
  import("@/views/admin-manager/ArchivePostDocs");
const managerDecidedPostDocs = () =>
  import("@/views/admin-manager/DecidedPostDocs");
const managerNeedPostDocs = () => import("@/views/admin-manager/NeedPostDocs");
const managerPostDoc = () => import("@/views/admin-manager/PostDoc");

// Elite
const managerActiveElites = () => import("@/views/admin-manager/ActiveElites");
const managerArchiveElites = () =>
  import("@/views/admin-manager/ArchiveElites");
const managerDecidedElites = () =>
  import("@/views/admin-manager/DecidedElites");
const managerNeedElites = () => import("@/views/admin-manager/NeedElites");
const managerElite = () => import("@/views/admin-manager/Elite");

// Admin Pages
// const PAGE = () =>
// import('@/views/admin-admin/PAGE)
const adminDashboard = () => import("@/views/admin-admin/Dashboard");
const adminReports = () => import("@/views/admin-admin/Reports");
const adminChangePassword = () => import("@/views/admin-admin/ChangePassword");
const adminProposals = () => import("@/views/admin-admin/Proposals");
const adminPostDoc = () => import("@/views/admin-admin/PostDoc");
const adminArticle = () => import("@/views/admin-admin/Article");
const adminMeeting = () => import("@/views/admin-admin/Meeting");
const adminMasterProposal = () => import("@/views/admin-admin/MasterProposal");
const adminOpportunity = () => import("@/views/admin-admin/Opportunity");
const adminPhdProposal = () => import("@/views/admin-admin/PhdProposal");
const adminElite = () => import("@/views/admin-admin/Elite");
const adminNewPc = () => import("@/views/admin-admin/NewPc");
const adminGoingPc = () => import("@/views/admin-admin/GoingPc");
const adminArchivePc = () => import("@/views/admin-admin/ArchivePc");
const adminReport = () => import("@/views/admin-admin/reports/Reports");
const adminUniversityReport = () =>
  import("@/views/admin-admin/reports/UniversityReport");
const adminCatReport = () => import("@/views/admin-admin/reports/CatReport");
const adminUniRequestReport = () =>
  import("@/views/admin-admin/reports/UniRequestReport");
const adminPersonalReport = () =>
  import("@/views/admin-admin/reports/PersonalReport");
const adminRequestsReport = () =>
  import("@/views/admin-admin/reports/RequestsReport");
const adminAcceleratorReport = () =>
  import("@/views/admin-admin/reports/AcceleratorReport");
const adminSystemVisits = () => import("@/views/admin-admin/SystemVisits");
// Proposal
const adminActiveProposals = () =>
  import("@/views/admin-admin/ActiveProposals");
const adminDecidedProposals = () =>
  import("@/views/admin-admin/DecidedProposals");
const adminNeedEditProposals = () =>
  import("@/views/admin-admin/NeedEditProposals");
const adminCanceledProposals = () =>
  import("@/views/admin-admin/CanceledProposals");
const adminProposal = () => import("@/views/admin-admin/Proposal");
const adminProposalCp = () => import("@/views/admin-admin/ProposalCp");
const adminWaitingforCommercializingProposals = () =>
  import("@/views/admin-admin/WaitingforCommercializingProposals");
const adminWaitingforCommercializingPhds = () =>
  import("@/views/admin-admin/WaitingforCommercializingPhds");
const adminWaitingforCommercializingMasters = () =>
  import("@/views/admin-admin/WaitingforCommercializingMasters");
const adminWatingforCommercializingOpportunities = () =>
  import("@/views/admin-admin/WaitingforCommercializingOpportunities");
const adminWatingforCommercializingPostDocs = () =>
  import("@/views/admin-admin/WaitingforCommercializingPostDoc");

// PhD
const adminActivePhds = () => import("@/views/admin-admin/ActivePhds");
const adminDecidedPhds = () => import("@/views/admin-admin/DecidedPhds");
const adminNeedEditPhds = () => import("@/views/admin-admin/NeedEditPhds");
const adminCanceledPhds = () => import("@/views/admin-admin/CanceledPhds");
const adminPhdProposalCp = () => import("@/views/admin-admin/PhdProposalCp");

// Master
const adminActiveMasters = () => import("@/views/admin-admin/ActiveMasters");
const adminDecidedMasters = () => import("@/views/admin-admin/DecidedMasters");
const adminNeedEditMasters = () =>
  import("@/views/admin-admin/NeedEditMasters");
const adminCanceledMasters = () =>
  import("@/views/admin-admin/CanceledMasters");
const adminMasterProposalCp = () =>
  import("@/views/admin-admin/MasterProposalCp");

// Article
const adminActiveArticles = () => import("@/views/admin-admin/ActiveArticles");
const adminDecidedArticles = () =>
  import("@/views/admin-admin/DecidedArticles");
const adminNeedEditArticles = () =>
  import("@/views/admin-admin/NeedEditArticles");
const adminCanceledArticles = () =>
  import("@/views/admin-admin/CanceledArticles");

// Study Abroad Opportunity
const adminActiveOpportunities = () =>
  import("@/views/admin-admin/ActiveOpportunities");
const adminDecidedOpportunities = () =>
  import("@/views/admin-admin/DecidedOpportunities");
const adminNeedEditOpportunities = () =>
  import("@/views/admin-admin/NeedEditOpportunities");
const adminCanceledOpportunities = () =>
  import("@/views/admin-admin/CanceledOpportunities");
const adminOpportunityCp = () => import("@/views/admin-admin/OpportunityCp");

// Scientific Meeting Report
const adminActiveMeetings = () => import("@/views/admin-admin/ActiveMeetings");
const adminDecidedMeetings = () =>
  import("@/views/admin-admin/DecidedMeetings");
const adminNeedEditMeetings = () =>
  import("@/views/admin-admin/NeedEditMeetings");
const adminCanceledMeetings = () =>
  import("@/views/admin-admin/CanceledMeetings");
const adminMeetingCp = () => import("@/views/admin-admin/MeetingCp");

// PostDoctorate
const adminActivePostDocs = () => import("@/views/admin-admin/ActivePostDocs");
const adminDecidedPostDocs = () =>
  import("@/views/admin-admin/DecidedPostDocs");
const adminNeedEditPostDocs = () =>
  import("@/views/admin-admin/NeedEditPostDocs");
const adminCanceledPostDocs = () =>
  import("@/views/admin-admin/CanceledPostDocs");
const adminPostDocCp = () => import("@/views/admin-admin/PostDocCp");

// Elite
const adminActiveElites = () => import("@/views/admin-admin/ActiveElites");
const adminDecidedElites = () => import("@/views/admin-admin/DecidedElites");
const adminNeedEditElites = () => import("@/views/admin-admin/NeedEditElites");
const adminCanceledElites = () => import("@/views/admin-admin/CanceledElites");
const adminEliteCp = () => import("@/views/admin-admin/EliteCp");

const adminArchive = () => import("@/views/admin-admin/Archive");
const adminUsers = () => import("@/views/admin-admin/Users");
const adminUser = () => import("@/views/admin-admin/User");
const adminUniversities = () => import("@/views/admin-admin/Universities");
const adminCompanies = () => import("@/views/admin-admin/Companies");
const adminAddCompany = () => import("@/views/admin-admin/AddCompany");
const adminUniversity = () => import("@/views/admin-admin/University");
const adminCompanyId = () => import("@/views/admin-admin/Company");
const adminAccelerators = () => import("@/views/admin-admin/Accelerators");
const adminAddAccelerator = () => import("@/views/admin-admin/AddAccelerator");
const adminAcceleratorId = () => import("@/views/admin-admin/Accelerator");
const adminOrganizations = () => import("@/views/admin-admin/Organizations");
const adminAddOrganization = () =>
  import("@/views/admin-admin/AddOrganization");
// const adminOrganizationId = () => import("@/views/admin-admin/Organization");
const adminAddUniversity = () => import("@/views/admin-admin/AddUniversity");
const adminTopics = () => import("@/views/admin-admin/Topics");
const adminReviewers = () => import("@/views/admin-admin/Reviewers");
const adminReviewer = () => import("@/views/admin-admin/Reviewer");
const adminAddReviewer = () => import("@/views/admin-admin/AddReviewer");
const adminRejectionType = () => import("@/views/admin-admin/RejectionType");
const adminFastSubmission = () => import("@/views/admin-admin/FastSubmission");
const adminFastProposal = () => import("@/views/admin-admin/FastProposal");
const adminFastPhd = () => import("@/views/admin-admin/FastPhd");
const adminFastMaster = () => import("@/views/admin-admin/FastMaster");
const adminFastArticle = () => import("@/views/admin-admin/FastArticle");
const adminFastAddResearcher = () =>
  import("@/views/admin-admin/FastAddResearcher");
const adminFastOpportunity = () =>
  import("@/views/admin-admin/FastOpportunity");
const adminFastMeeting = () => import("@/views/admin-admin/FastMeeting");
const adminFastPostDoc = () => import("@/views/admin-admin/FastPostDoc");
const adminFastElite = () => import("@/views/admin-admin/FastElite");

// To Do Pages
const adminToDoRegistered = () => import("@/views/admin-admin/todo/Registered");
const adminToDoUnderSupervision = () =>
  import("@/views/admin-admin/todo/UnderSupervision");
const adminToDoInReview = () => import("@/views/admin-admin/todo/InReview");
const adminToDoReviewDone = () => import("@/views/admin-admin/todo/ReviewDone");
const adminToDoCorrected = () => import("@/views/admin-admin/todo/Corrected");
const adminToDoInitialAccept = () =>
  import("@/views/admin-admin/todo/InitialAccept");
const adminToDoNewReports = () => import("@/views/admin-admin/todo/NewReports");

// Demands Pages
const adminDemandsRegistered = () =>
  import("@/views/admin-admin/demands/Registered");
const adminDemandsIncomplete = () =>
  import("@/views/admin-admin/demands/Incomplete");
const adminDemandsCorrected = () =>
  import("@/views/admin-admin/demands/Corrected");
const adminDemandsAccepted = () =>
  import("@/views/admin-admin/demands/Accepted");
const adminDemandsLetterSent = () =>
  import("@/views/admin-admin/demands/LetterSent");
const adminDemandsRejected = () =>
  import("@/views/admin-admin/demands/Rejected");
const adminDemandsFinalize = () =>
  import("@/views/admin-admin/demands/Finalize");
const adminDemandId = () => import("@/views/admin-admin/demands/Demand");

// UniRequests Pages
const adminUniRequestsRegistered = () =>
  import("@/views/admin-admin/uniRequests/Registered");
const adminUniRequestsIncomplete = () =>
  import("@/views/admin-admin/uniRequests/Incomplete");
const adminUniRequestsCorrected = () =>
  import("@/views/admin-admin/uniRequests/Corrected");
const adminUniRequestsAccepted = () =>
  import("@/views/admin-admin/uniRequests/Accepted");
const adminUniRequestsRejected = () =>
  import("@/views/admin-admin/uniRequests/Rejected");
const adminUniRequestsFinalize = () =>
  import("@/views/admin-admin/uniRequests/Finalize");
const adminUniRequestId = () =>
  import("@/views/admin-admin/uniRequests/UniRequest");

// ResearcherUniRequests Pages
const adminResearcherUniRequestsRegistered = () =>
  import("@/views/admin-admin/researcherUniRequests/Registered");
const adminResearcherUniRequestsIncomplete = () =>
  import("@/views/admin-admin/researcherUniRequests/Incomplete");
const adminResearcherUniRequestsCorrected = () =>
  import("@/views/admin-admin/researcherUniRequests/Corrected");
const adminResearcherUniRequestsAccepted = () =>
  import("@/views/admin-admin/researcherUniRequests/Accepted");
const adminResearcherUniRequestsRejected = () =>
  import("@/views/admin-admin/researcherUniRequests/Rejected");
const adminResearcherUniRequestsFinalize = () =>
  import("@/views/admin-admin/researcherUniRequests/Finalize");
const adminResearcherUniRequestId = () =>
  import("@/views/admin-admin/researcherUniRequests/ResearcherUniRequest");

const adminBanners = () => import("@/views/admin-admin/Banners");

// head Pages
// const PAGE = () =>
// import('@/views/admin-head/PAGE)
const headDashboard = () => import("@/views/admin-head/Dashboard");
const headReports = () => import("@/views/admin-head/Reports");
const headChangePassword = () => import("@/views/admin-head/ChangePassword");
const headPostDoc = () => import("@/views/admin-head/PostDoc");
const headArticle = () => import("@/views/admin-head/Article");
const headMeeting = () => import("@/views/admin-head/Meeting");
const headMasterProposal = () => import("@/views/admin-head/MasterProposal");
const headOpportunity = () => import("@/views/admin-head/Opportunity");
const headPhdProposal = () => import("@/views/admin-head/PhdProposal");
const headElite = () => import("@/views/admin-head/Elite");
const headNewPc = () => import("@/views/admin-head/NewPc");
const headGoingPc = () => import("@/views/admin-head/GoingPc");
const headArchivePc = () => import("@/views/admin-head/ArchivePc");
// Proposal
const headActiveProposals = () => import("@/views/admin-head/ActiveProposals");
const headDecidedProposals = () =>
  import("@/views/admin-head/DecidedProposals");
const headNeedEditProposals = () =>
  import("@/views/admin-head/NeedEditProposals");
const headCanceledProposals = () =>
  import("@/views/admin-head/CanceledProposals");
const headProposal = () => import("@/views/admin-head/Proposal");
const headProposalCp = () => import("@/views/admin-head/ProposalCp");

// PhD
const headActivePhds = () => import("@/views/admin-head/ActivePhds");
const headDecidedPhds = () => import("@/views/admin-head/DecidedPhds");
const headNeedEditPhds = () => import("@/views/admin-head/NeedEditPhds");
const headCanceledPhds = () => import("@/views/admin-head/CanceledPhds");
const headPhdProposalCp = () => import("@/views/admin-head/PhdProposalCp");

// Master
const headActiveMasters = () => import("@/views/admin-head/ActiveMasters");
const headDecidedMasters = () => import("@/views/admin-head/DecidedMasters");
const headNeedEditMasters = () => import("@/views/admin-head/NeedEditMasters");
const headCanceledMasters = () => import("@/views/admin-head/CanceledMasters");
const headMasterProposalCp = () =>
  import("@/views/admin-head/MasterProposalCp");

// Article
const headActiveArticles = () => import("@/views/admin-head/ActiveArticles");
const headDecidedArticles = () => import("@/views/admin-head/DecidedArticles");
const headNeedEditArticles = () =>
  import("@/views/admin-head/NeedEditArticles");
const headCanceledArticles = () =>
  import("@/views/admin-head/CanceledArticles");

// Study Abroad Opportunity
const headActiveOpportunities = () =>
  import("@/views/admin-head/ActiveOpportunities");
const headDecidedOpportunities = () =>
  import("@/views/admin-head/DecidedOpportunities");
const headNeedEditOpportunities = () =>
  import("@/views/admin-head/NeedEditOpportunities");
const headCanceledOpportunities = () =>
  import("@/views/admin-head/CanceledOpportunities");
const headOpportunityCp = () => import("@/views/admin-head/OpportunityCp");

// Scientific Meeting Report
const headActiveMeetings = () => import("@/views/admin-head/ActiveMeetings");
const headDecidedMeetings = () => import("@/views/admin-head/DecidedMeetings");
const headNeedEditMeetings = () =>
  import("@/views/admin-head/NeedEditMeetings");
const headCanceledMeetings = () =>
  import("@/views/admin-head/CanceledMeetings");
const headMeetingCp = () => import("@/views/admin-head/MeetingCp");

// PostDoctorate
const headActivePostDocs = () => import("@/views/admin-head/ActivePostDocs");
const headDecidedPostDocs = () => import("@/views/admin-head/DecidedPostDocs");
const headNeedEditPostDocs = () =>
  import("@/views/admin-head/NeedEditPostDocs");
const headCanceledPostDocs = () =>
  import("@/views/admin-head/CanceledPostDocs");
const headPostDocCp = () => import("@/views/admin-head/PostDocCp");

// Elite
const headActiveElites = () => import("@/views/admin-head/ActiveElites");
const headDecidedElites = () => import("@/views/admin-head/DecidedElites");
const headNeedEditElites = () => import("@/views/admin-head/NeedEditElites");
const headCanceledElites = () => import("@/views/admin-head/CanceledElites");
const headEliteCp = () => import("@/views/admin-head/EliteCp");

const headArchive = () => import("@/views/admin-head/Archive");
const headUsers = () => import("@/views/admin-head/Users");
const headUniversities = () => import("@/views/admin-head/Universities");
const headTopics = () => import("@/views/admin-head/Topics");
const headReviewers = () => import("@/views/admin-head/Reviewers");
const headRejectionType = () => import("@/views/admin-head/RejectionType");

// Company Manager Pages
// const PAGE = () =>
// import('@/views/admin-companyManager/PAGE)
const companyManagerDashboard = () =>
  import("@/views/admin-companyManager/Dashboard");
const companyManagerAddCompany = () =>
  import("@/views/admin-companyManager/AddCompany");
const companyManagerCompanies = () =>
  import("@/views/admin-companyManager/Companies");
const companyManagerCompany = () =>
  import("@/views/admin-companyManager/Company");
const companyManagerChangePassword = () =>
  import("@/views/admin-companyManager/ChangePassword");

//public pages
//map
const Map = () => import("@/views/map/Map");
const UniversityProfile = () => import("@/views/map/UniversityProfile");
const UniversityFacultyMembers = () => import("@/views/map/UniversityFaculty");
const UniversityImages = () => import("@/views/map/UniversityImages");
const CompanyProfile = () => import("@/views/map/CompanyProfile");
const CompanyImages = () => import("@/views/map/CompanyImages");
const AcceleratorProfile = () => import("@/views/map/AcceleratorProfile");
const AcceleratorImages = () => import("@/views/map/AcceleratorImages");
const mapResearcherProfile = () => import("@/views/map/ResearcherProfile");

//Cities Management
const CitiesManagement = () => import("@/views/admin-admin/CitiesManagement");
//Map Settings
const MapSettings = () => import("@/views/admin-admin/MapSettings");

export default new Router({
  mode: "history",
  linkActiveClass: "open active",
  scrollBehavior: () => ({ y: 0 }),
  routes: [
    // manager Routes
    {
      path: "/manager",
      redirect: "/manager/dashboard",
      // meta: { label: 'خانه' },
      // name: 'manager_home',
      component: DefaultContainer,
      children: [
        {
          path: "/manager/dashboard",
          name: "رییس گروه",
          component: managerDashboard,
          children: [
            {
              path: "/manager/changelog",
              name: "تغییرات هر نسخه",
              component: ChangeLog,
            },
            // Proposal
            {
              path: "/manager/activeProposals",
              name: " طرح‌های در دست بررسی",
              component: managerActiveProposals,
            },
            {
              path: "/manager/proposal/:id",
              name: " شناسنامه طرح",
              component: managerProposal,
            },
            {
              path: "/manager/archiveProposals",
              name: " آرشیو طرح‌ها",
              component: managerArchiveProposals,
            },
            {
              path: "/manager/decidedProposals",
              name: " طرح‌های تصمیم گیری شده",
              component: managerDecidedProposals,
            },
            {
              path: "/manager/needProposals",
              name: " طرح‌های نیاز به اقدام",
              component: managerNeedProposals,
            },

            // PhD
            {
              path: "/manager/activePhds",
              name: " رساله‌های در دست بررسی",
              component: managerActivePhds,
            },
            {
              path: "/manager/phdProposal/:id",
              name: " شناسنامه رساله",
              component: managerPhdProposal,
            },
            {
              path: "/manager/archivePhds",
              name: " آرشیو رساله‌ها",
              component: managerArchivePhds,
            },
            {
              path: "/manager/decidedPhds",
              name: " رساله‌های تصمیم گیری شده",
              component: managerDecidedPhds,
            },
            {
              path: "/manager/needPhds",
              name: " رساله‌های نیاز به اقدام",
              component: managerNeedPhds,
            },

            // Master
            {
              path: "/manager/activeMasterProposals",
              name: " پایان‌نامه‌های در دست بررسی",
              component: managerActiveMasters,
            },
            {
              path: "/manager/masterProposal/:id",
              name: " شناسنامه پایان‌نامه",
              component: managerMasterProposal,
            },
            {
              path: "/manager/archiveMasterProposals",
              name: " آرشیو پایان‌نامه‌ها",
              component: managerArchiveMasters,
            },
            {
              path: "/manager/decidedMasterProposals",
              name: " پایان‌نامه‌های تصمیم گیری شده",
              component: managerDecidedMasters,
            },
            {
              path: "/manager/needMasterProposals",
              name: " پایان‌نامه‌های نیاز به اقدام",
              component: managerNeedMasters,
            },

            // Article
            {
              path: "/manager/activeArticles",
              name: " مقاله‌های در دست بررسی",
              component: managerActiveArticles,
            },
            {
              path: "/manager/article/:id",
              name: " شناسنامه مقاله",
              component: managerArticle,
            },
            {
              path: "/manager/archiveArticles",
              name: " آرشیو مقالات",
              component: managerArchiveArticles,
            },
            {
              path: "/manager/decidedArticles",
              name: " مقاله‌های تصمیم گیری شده",
              component: managerDecidedArticles,
            },
            {
              path: "/manager/needArticles",
              name: " مقاله‌های نیاز به اقدام",
              component: managerNeedArticles,
            },

            // Study Abroad Opportunity
            {
              path: "/manager/activeOpportunities",
              name: " فرصت‌‍‌های در دست بررسی",
              component: managerActiveOpportunities,
            },
            {
              path: "/manager/opportunity/:id",
              name: " شناسنامه فرصت",
              component: managerOpportunity,
            },
            {
              path: "/manager/archiveOpportunities",
              name: " آرشیو فرصت‌‍‌ها",
              component: managerArchiveOpportunities,
            },
            {
              path: "/manager/decidedOpportunities",
              name: " فرصت‌‍‌های تصمیم گیری شده",
              component: managerDecidedOpportunities,
            },
            {
              path: "/manager/needOpportunities",
              name: " فرصت‌‍‌های نیاز به اقدام",
              component: managerNeedOpportunities,
            },

            // Scientific Meeting Report
            {
              path: "/manager/activeMeetings",
              name: " نشست‌های در دست بررسی",
              component: managerActiveMeetings,
            },
            {
              path: "/manager/meeting/:id",
              name: " شناسنامه نشست",
              component: managerMeeting,
            },
            {
              path: "/manager/archiveMeetings",
              name: " آرشیو نشست‌ها",
              component: managerArchiveMeetings,
            },
            {
              path: "/manager/decidedMeetings",
              name: "نشست‌های تصمیم گیری شده",
              component: managerDecidedMeetings,
            },
            {
              path: "/manager/needMeetings",
              name: " نشست‌های نیاز به اقدام",
              component: managerNeedMeetings,
            },

            // PostDoctorate
            {
              path: "/manager/activePostDocs",
              name: " دوره‌های در دست بررسی",
              component: managerActivePostDocs,
            },
            {
              path: "/manager/postDoc/:id",
              name: " شناسنامه دوره",
              component: managerPostDoc,
            },
            {
              path: "/manager/archivePostDocs",
              name: " آرشیو دوره‌ها",
              component: managerArchivePostDocs,
            },
            {
              path: "/manager/decidedPostDocs",
              name: " دوره‌های تصمیم گیری شده",
              component: managerDecidedPostDocs,
            },
            {
              path: "/manager/needPostDocs",
              name: " دوره‌های نیاز به اقدام",
              component: managerNeedPostDocs,
            },

            // Elite
            {
              path: "/manager/activeElites",
              name: " نخبه وظیفه در دست بررسی",
              component: managerActiveElites,
            },
            {
              path: "/manager/elite/:id",
              name: " شناسنامه نخبه",
              component: managerElite,
            },
            {
              path: "/manager/archiveElites",
              name: " آرشیو نخبگان وظیفه ",
              component: managerArchiveElites,
            },
            {
              path: "/manager/decidedElites",
              name: " نخبه وظیفه تصمیم گیری شده",
              component: managerDecidedElites,
            },
            {
              path: "/manager/needElites",
              name: " نخبه وظیفه نیاز به اقدام",
              component: managerNeedElites,
            },
            {
              path: "/manager/changepassword",
              name: "تغییر رمز عبور ",
              component: managerChangePassword,
            },
            {
              path: "/manager/guide",
              name: "  راهنما",
              component: guide,
            },
          ],
        },
      ],
    },
    // Referee Routes
    {
      path: "/referee",
      redirect: "/referee/dashboard",
      // meta: { label: 'خانه' },
      // name: 'referee_home',

      component: DefaultContainer,
      children: [
        {
          path: "/referee/dashboard",
          name: "داور",
          component: refereeDashboard,
          children: [
            {
              path: "/referee/changelog",
              name: "تغییرات هر نسخه",
              component: ChangeLog,
            },
            {
              path: "/referee/archive",
              name: "آرشیو داوری‌ها",
              component: refereeArchive,
            },
            {
              path: "/referee/reviews",
              name: "داوری‌های در انتظار",
              component: refereeReviews,
              children: [
                {
                  path: "/referee/reviewArticle/:id/:judgeId",
                  name: "داوری مقاله",
                  component: refereeReviewArticle,
                },
                {
                  path: "/referee/reviewElite/:id/:judgeId",
                  name: "داوری نخبگان",
                  component: refereeReviewElite,
                },
                {
                  path: "/referee/reviewMaster/:id/:judgeId",
                  name: "داوری پایان‌نامه ارشد",
                  component: refereeReviewMaster,
                },
                {
                  path: "/referee/reviewMeeting/:id/:judgeId",
                  name: "داوری نشست تخصصی",
                  component: refereeReviewMeeting,
                },
                {
                  path: "/referee/reviewOpportunity/:id/:judgeId",
                  name: "داوری فرصت مطالعاتی",
                  component: refereeReviewOpportunity,
                },
                {
                  path: "/referee/reviewPhd/:id/:judgeId",
                  name: "داوری رساله دکتری",
                  component: refereeReviewPhd,
                },
                {
                  path: "/referee/reviewPostDoc/:id/:judgeId",
                  name: "داوری دوره پسادکتری",
                  component: refereeReviewPostDoc,
                },
                {
                  path: "/referee/reviewProposal/:id/:judgeId",
                  name: "داوری طرح",
                  component: refereeReviewProposal,
                },
              ],
            },
            {
              path: "/referee/profile",
              name: "حساب کاربری",
              component: refereeProfile,
            },
            {
              path: "/referee/doneProjectsControl",
              name: "انجام شده‌ها",
              component: refereeDoneProjectsControl,
            },
            {
              path: "/referee/projectsControl",
              name: "گزارش‌ها",
              component: refereeProjectsControl,
            },

            {
              path: "/referee/proposalCp/:id",
              name: " طرح پژوهشی",
              component: refereeProposalCp,
            },
            {
              path: "/referee/phdProposalCp/:id",
              name: " رساله دکتری",
              component: refereePhdProposalCp,
            },
            {
              path: "/referee/masterProposalCp/:id",
              name: " پایان‌نامه ارشد",
              component: refereeMasterProposalCp,
            },
            {
              path: "/referee/meetingCp/:id",
              name: " نشست تخصصی",
              component: refereeMeetingCp,
            },
            {
              path: "/referee/opportunityCp/:id",
              name: " فرصت مطالعاتی",
              component: refereeOpportunityCp,
            },
            {
              path: "/referee/postDocCp/:id",
              name: " پسا دکتری",
              component: refereePostDocCp,
            },
            {
              path: "/referee/eliteCp/:id",
              name: " نخبه وظیفه",
              component: refereeEliteCp,
            },
            {
              path: "/referee/guide",
              name: "راهنما ",
              component: guide,
            },
          ],
        },
      ],
    },
    // Admin Routes
    {
      path: "/admin",
      redirect: "/admin/dashboard",
      // meta: { label: 'خانه' },
      // name: 'admin_home',
      component: DefaultContainer,
      children: [
        // Admin Pages
        {
          path: "/admin/dashboard",
          name: "مدیر",
          component: adminDashboard,
          children: [
            {
              path: "/admin/changelog",
              name: "تغییرات هر نسخه",
              component: ChangeLog,
            },
            {
              path: "/admin/proposals",
              name: "طرح‌های فعال",
              component: adminProposals,
            },
            {
              path: "/admin/proposalCp/:id",
              name: "طرح پژوهشی",
              component: underDevelopment ? ComingSoon : adminProposalCp,
            },
            {
              path: "/admin/postDocCp/:id",
              name: "پسادکتری ",
              component: underDevelopment ? ComingSoon : adminPostDocCp,
            },
            {
              path: "/admin/phdProposalCp/:id",
              name: "رساله‌دکتری",
              component: underDevelopment ? ComingSoon : adminPhdProposalCp,
            },
            {
              path: "/admin/masterProposalCp/:id",
              name: "پایان‌نامه‌ارشد",
              component: underDevelopment ? ComingSoon : adminMasterProposalCp,
            },
            {
              path: "/admin/opportunityCp/:id",
              name: " فرصت مطالعاتی ",
              component: underDevelopment ? ComingSoon : adminOpportunityCp,
            },
            {
              path: "/admin/meetingCp/:id",
              name: " نشست تخصصی ",
              component: underDevelopment ? ComingSoon : adminMeetingCp,
            },
            {
              path: "/admin/eliteCp/:id",
              name: " نخبه وظیفه ",
              component: underDevelopment ? ComingSoon : adminEliteCp,
            },
            {
              path: "/admin/reports",
              name: "گزارش‌ها",
              component: adminReports,
            },
            {
              path: "/admin/advancedReport",
              name: "گزارش‌ پیشرفته",
              component: adminReport,
            },
            {
              path: "/admin/systemVisits",
              name: "گزارش‌ فعالیت",
              component: adminSystemVisits,
            },
            {
              path: "/admin/uniRequestReport",
              name: "گزارش‌ طرح‌های کلان",
              component: adminUniRequestReport,
            },
            {
              path: "/admin/catReport",
              name: "گزارش‌ موضوعاات",
              component: adminCatReport,
            },
            {
              path: "/admin/universityReport",
              name: "گزارش‌ دانشگاه",
              component: adminUniversityReport,
            },
            {
              path: "/admin/personalReport",
              name: "گزارش‌ فردی",
              component: adminPersonalReport,
            },
            {
              path: "/admin/requestsReport",
              name: "گزارش حمایت ها و محور ها",
              component: adminRequestsReport,
            },
            {
              path: "/admin/acceleratorReport",
              name: "گزارش شتاب‌دهنده‌ها",
              component: adminAcceleratorReport,
            },
            {
              path: "/admin/newPc",
              name: "جدیدها",
              component: adminNewPc,
            },
            {
              path: "/admin/goingPc",
              name: "در حال انجام‌ها",
              component: adminGoingPc,
            },
            {
              path: "/admin/archivePc",
              name: "آرشیو",
              component: adminArchivePc,
            },
            {
              path: "/admin/changepassword",
              name: "تغییر رمز عبور",
              component: adminChangePassword,
            },
            {
              path: "/admin/activeProposals",
              name: "طرح‌های در دست بررسی",
              component: adminActiveProposals,
            },
            {
              path: "/admin/decidedProposals",
              name: "طرح‌های تایید شده",
              component: adminDecidedProposals,
            },
            {
              path: "/admin/needEditProposals",
              name: "طرح‌های نیازمند بازنگری",
              component: adminNeedEditProposals,
            },
            {
              path: "/admin/canceledProposals",
              name: "طرح‌های رد شده",
              component: adminCanceledProposals,
            },
            {
              path: "/admin/watingforCommercializingProposals",
              name: "طرح‌های در انتظار تجاری‌سازی",
              component: adminWaitingforCommercializingProposals,
            },
            {
              path: "/admin/watingforCommercializingPhds",
              name: "رساله‌های در انتظار تجاری‌سازی",
              component: adminWaitingforCommercializingPhds,
            },
            {
              path: "/admin/watingforCommercializingMasters",
              name: "پایان‌نامه‌های در انتظار تجاری‌سازی",
              component: adminWaitingforCommercializingMasters,
            },
            {
              path: "/admin/watingforCommercializingOpportunities",
              name: "فرصت‌های در انتظار تجاری‌سازی",
              component: adminWatingforCommercializingOpportunities,
            },
            {
              path: "/admin/watingforCommercializingPostDocs",
              name: "دوره‌های در انتظار تجاری‌سازی",
              component: adminWatingforCommercializingPostDocs,
            },
            {
              path: "/admin/proposal/:id",
              name: "شناسنامه طرح",
              component: adminProposal,
            },
            {
              path: "/admin/archive",
              name: "آرشیو طرح‌ها",
              component: adminArchive,
            },

            // PhD
            {
              path: "/admin/activePhds",
              name: "رساله‌های در دست بررسی",
              component: adminActivePhds,
            },
            {
              path: "/admin/phdProposal/:id",
              name: "شناسنامه رساله",
              component: adminPhdProposal,
            },
            {
              path: "/admin/decidedPhds",
              name: "رساله‌های تایید شده",
              component: adminDecidedPhds,
            },
            {
              path: "/admin/needEditPhds",
              name: "رساله‌های نیازمند بازنگری",
              component: adminNeedEditPhds,
            },
            {
              path: "/admin/canceledPhds",
              name: "رساله‌های رد شده",
              component: adminCanceledPhds,
            },

            // Master
            {
              path: "/admin/activeMasters",
              name: "پایان‌نامه‌های در دست بررسی",
              component: adminActiveMasters,
            },
            {
              path: "/admin/masterProposal/:id",
              name: "شناسنامه پایان‌نامه",
              component: adminMasterProposal,
            },
            {
              path: "/admin/decidedMasters",
              name: "پایان‌نامه‌های تایید شده",
              component: adminDecidedMasters,
            },
            {
              path: "/admin/needEditMasters",
              name: "پایان‌نامه‌های نیازمند بازنگری",
              component: adminNeedEditMasters,
            },
            {
              path: "/admin/canceledMasters",
              name: "پایان‌نامه‌های رد شده",
              component: adminCanceledMasters,
            },

            // Article
            {
              path: "/admin/activeArticles",
              name: "مقاله‌های در دست بررسی",
              component: adminActiveArticles,
            },
            {
              path: "/admin/Article/:id",
              name: "شناسنامه مقاله",
              component: adminArticle,
            },
            {
              path: "/admin/decidedArticles",
              name: "مقاله‌های تایید شده",
              component: adminDecidedArticles,
            },
            {
              path: "/admin/needEditArticles",
              name: "مقاله‌های نیازمند بازنگری",
              component: adminNeedEditArticles,
            },
            {
              path: "/admin/canceledArticles",
              name: "مقاله‌های رد شده",
              component: adminCanceledArticles,
            },

            // Study Abroad Opportunity
            {
              path: "/admin/activeOpportunities",
              name: "فرصت‌‍‌های در دست بررسی",
              component: adminActiveOpportunities,
            },
            {
              path: "/admin/opportunity/:id",
              name: "شناسنامه فرصت",
              component: adminOpportunity,
            },
            {
              path: "/admin/decidedOpportunities",
              name: "فرصت‌‍‌های تایید شده",
              component: adminDecidedOpportunities,
            },
            {
              path: "/admin/needEditOpportunities",
              name: "فرصت‌‍‌های نیازمند بازنگری",
              component: adminNeedEditOpportunities,
            },
            {
              path: "/admin/canceledOpportunities",
              name: "فرصت‌‍‌های رد شده",
              component: adminCanceledOpportunities,
            },

            // Scientific Meeting Report
            {
              path: "/admin/activeMeetings",
              name: "نشست‌های در دست بررسی",
              component: adminActiveMeetings,
            },
            {
              path: "/admin/Meeting/:id",
              name: "شناسنامه نشست",
              component: adminMeeting,
            },
            {
              path: "/admin/decidedMeetings",
              name: "نشست‌های تایید شده",
              component: adminDecidedMeetings,
            },
            {
              path: "/admin/needEditMeetings",
              name: "نشست‌های نیازمند بازنگری",
              component: adminNeedEditMeetings,
            },
            {
              path: "/admin/canceledMeetings",
              name: "نشست‌های رد شده",
              component: adminCanceledMeetings,
            },

            // PostDoctorate
            {
              path: "/admin/activePostDocs",
              name: "دوره‌های در دست بررسی",
              component: adminActivePostDocs,
            },
            {
              path: "/admin/PostDoc/:id",
              name: "شناسنامه پسادکتری",
              component: adminPostDoc,
            },
            {
              path: "/admin/decidedPostDocs",
              name: "دوره‌های تایید شده",
              component: adminDecidedPostDocs,
            },
            {
              path: "/admin/needEditPostDocs",
              name: "دوره‌های نیازمند بازنگری",
              component: adminNeedEditPostDocs,
            },
            {
              path: "/admin/canceledPostDocs",
              name: "دوره‌های رد شده",
              component: adminCanceledPostDocs,
            },

            // Elite
            {
              path: "/admin/activeElites",
              name: "نخبه وظیفه در دست بررسی",
              component: adminActiveElites,
            },
            {
              path: "/admin/Elite/:id",
              name: "شناسنامه نخبه",
              component: adminElite,
            },
            {
              path: "/admin/decidedElites",
              name: "نخبه وظیفه تایید شده",
              component: adminDecidedElites,
            },
            {
              path: "/admin/needEditElites",
              name: "نخبه وظیفه نیازمند بازنگری",
              component: adminNeedEditElites,
            },
            {
              path: "/admin/canceledElites",
              name: "نخبه وظیفه رد شده",
              component: adminCanceledElites,
            },

            {
              path: "/admin/users",
              name: "پژوهشگران",
              component: adminUsers,
              children: [
                {
                  path: "/admin/user/:id",
                  name: "اطلاعات پژوهشگر",
                  component: adminUser,
                },
                {
                  path: "/admin/addUser",
                  name: " پژوهشگر جدید",
                  component: adminFastAddResearcher,
                },
              ],
            },
            {
              path: "/admin/universities",
              name: "لیست دانشگاه‌ها",
              component: adminUniversities,
              children: [
                {
                  path: "/admin/university/:id",
                  name: "پروفایل دانشگاه",
                  component: adminUniversity,
                },
                {
                  path: "/admin/addUniversity",
                  name: "دانشگاه جدید",
                  component: adminAddUniversity,
                },
              ],
            },
            {
              path: "/admin/companies",
              name: "لیست شرکت‌ها",
              component: adminCompanies,
              children: [
                {
                  path: "/admin/company/:id",
                  name: "پروفایل شرکت",
                  component: adminCompanyId,
                },
                {
                  path: "/admin/addCompany",
                  name: "شرکت جدید",
                  component: adminAddCompany,
                },
              ],
            },
            {
              path: "/admin/accelerators",
              name: "لیست شتاب‌دهنده‌‌ها",
              component: adminAccelerators,
              children: [
                {
                  path: "/admin/accelerator/:id",
                  name: "پروفایل شتاب‌دهنده",
                  component: adminAcceleratorId,
                },
                {
                  path: "/admin/addAccelerator",
                  name: "شتاب‌دهنده جدید",
                  component: adminAddAccelerator,
                },
              ],
            },
            {
              path: "/admin/organizations",
              name: "لیست انجمن‌های دانشجویی",
              component: adminOrganizations,
              children: [
                // {
                //   path: "/admin/organization/:id",
                //   name: "پروفایل شتاب‌دهنده",
                //   component: adminOrganizationId,
                // },
                {
                  path: "/admin/addOrganization",
                  name: "انجمن دانشجویی جدید",
                  component: adminAddOrganization,
                },
              ],
            },
            {
              path: "/admin/topics",
              name: "لیست موضوعات و محورها",
              component: adminTopics,
            },
            {
              path: "/admin/reviewers",
              name: "داوران",
              component: adminReviewers,
              children: [
                {
                  path: "/admin/reviewer/:id",
                  name: "پروفایل داور",
                  component: adminReviewer,
                },
                {
                  path: "/admin/addReviewer",
                  name: "داور جدید",
                  component: adminAddReviewer,
                },
              ],
            },
            {
              path: "/admin/rejectionType",
              name: "دلایل رد درخواست",
              component: adminRejectionType,
            },
            {
              path: "/admin/fastSubmission",
              name: "ثبت درخواست سریع",
              component: adminFastSubmission,
            },
            {
              path: "/admin/fastProposal",
              name: "ثبت سریع طرح تحقیقاتی",
              component: adminFastProposal,
            },
            {
              path: "/admin/fastPhd",
              name: "ثبت سریع رساله دکتری",
              component: adminFastPhd,
            },
            {
              path: "/admin/fastMaster",
              name: "ثبت سریع پایان‌نامه ارشد",
              component: adminFastMaster,
            },
            {
              path: "/admin/fastArticle",
              name: "ثبت سریع مقاله",
              component: adminFastArticle,
            },
            {
              path: "/admin/fastOpportunity",
              name: "ثبت سریع فرصت مطالعاتی",
              component: adminFastOpportunity,
            },
            {
              path: "/admin/fastMeeting",
              name: "ثبت سریع نشست تخصصی",
              component: adminFastMeeting,
            },
            {
              path: "/admin/fastPostDoc",
              name: "ثبت سریع پسا دکتری",
              component: adminFastPostDoc,
            },
            {
              path: "/admin/fastElite",
              name: "ثبت سریع نخبه وظیفه",
              component: adminFastElite,
            },
            {
              path: "/admin/todo/registered",
              name: "درخواست‌های جدید",
              component: adminToDoRegistered,
            },
            {
              path: "/admin/todo/underSupervision",
              name: "حمایت‌های در حال بررسی",
              component: adminToDoUnderSupervision,
            },
            {
              path: "/admin/todo/inReview",
              name: "حمایت‌های در دست داوری",
              component: adminToDoInReview,
            },
            {
              path: "/admin/todo/reviewDone",
              name: "حمایت‌های داوری شده",
              component: adminToDoReviewDone,
            },
            {
              path: "/admin/todo/corrected",
              name: "حمایت‌های اصلاح شده",
              component: adminToDoCorrected,
            },
            {
              path: "/admin/todo/initialAccept",
              name: "حمایت‌های تایید شده",
              component: adminToDoInitialAccept,
            },
            {
              path: "/admin/todo/newReports",
              name: "گزارش‌های جدید کنترل پروژه",
              component: adminToDoNewReports,
            },
            {
              path: "/admin/demands/registered",
              name: "درخواست‌های حوزه فعالیت ثبت شده",
              component: adminDemandsRegistered,
            },
            {
              path: "/admin/demands/incomplete",
              name: "درخواست‌های حوزه فعالیت نیازمند اصلاح",
              component: adminDemandsIncomplete,
            },
            {
              path: "/admin/demands/corrected",
              name: "درخواست‌های حوزه فعالیت اصلاح شده",
              component: adminDemandsCorrected,
            },
            {
              path: "/admin/demands/accepted",
              name: "درخواست‌های حوزه فعالیت تایید شده",
              component: adminDemandsAccepted,
            },
            {
              path: "/admin/demands/letterSent",
              name: "درخواست‌های حوزه فعالیت نامه تاییدیه",
              component: adminDemandsLetterSent,
            },
            {
              path: "/admin/demands/rejected",
              name: "درخواست‌های حوزه فعالیت رد شده",
              component: adminDemandsRejected,
            },
            {
              path: "/admin/demands/finalize",
              name: "درخواست‌های حوزه فعالیت تایید نهایی شده",
              component: adminDemandsFinalize,
            },
            {
              path: "/admin/demands/demand/:id",
              name: "درخواست حوزه فعالیت",
              component: adminDemandId,
            },
            {
              path: "/admin/uniRequests/registered",
              name: "درخواست‌های طرح کلان ثبت شده",
              component: adminUniRequestsRegistered,
            },
            {
              path: "/admin/uniRequests/incomplete",
              name: "درخواست‌های طرح کلان نیازمند اصلاح",
              component: adminUniRequestsIncomplete,
            },
            {
              path: "/admin/uniRequests/corrected",
              name: "درخواست‌های طرح کلان اصلاح شده",
              component: adminUniRequestsCorrected,
            },
            {
              path: "/admin/uniRequests/accepted",
              name: "درخواست‌های طرح کلان تایید شده",
              component: adminUniRequestsAccepted,
            },
            {
              path: "/admin/uniRequests/rejected",
              name: "درخواست‌های طرح کلان رد شده",
              component: adminUniRequestsRejected,
            },
            {
              path: "/admin/uniRequests/finalize",
              name: "درخواست‌های طرح کلان تایید نهایی شده",
              component: adminUniRequestsFinalize,
            },
            {
              path: "/admin/uniRequests/uniRequest/:id",
              name: "درخواست طرح کلان",
              component: adminUniRequestId,
            },
            {
              path: "/admin/researcherUniRequests/registered",
              name: "درخواست‌های ریزپروژه طرح کلان ثبت شده",
              component: adminResearcherUniRequestsRegistered,
            },
            {
              path: "/admin/researcherUniRequests/incomplete",
              name: "درخواست‌های ریزپروژه طرح کلان نیازمند اصلاح",
              component: adminResearcherUniRequestsIncomplete,
            },
            {
              path: "/admin/researcherUniRequests/corrected",
              name: "درخواست‌های ریزپروژه طرح کلان اصلاح شده",
              component: adminResearcherUniRequestsCorrected,
            },
            {
              path: "/admin/researcherUniRequests/accepted",
              name: "درخواست‌های ریزپروژه طرح کلان تایید شده",
              component: adminResearcherUniRequestsAccepted,
            },
            {
              path: "/admin/researcherUniRequests/rejected",
              name: "درخواست‌های ریزپروژه طرح کلان رد شده",
              component: adminResearcherUniRequestsRejected,
            },
            {
              path: "/admin/researcherUniRequests/finalize",
              name: "درخواست‌های ریزپروژه طرح کلان تایید نهایی شده",
              component: adminResearcherUniRequestsFinalize,
            },
            {
              path: "/admin/researcherUniRequests/request/:id",
              name: "درخواست ریزپروژه طرح کلان",
              component: adminResearcherUniRequestId,
            },
            {
              path: "/admin/guide",
              name: " راهنما ",
              component: guide,
            },
            {
              path: "/admin/citiesManagement",
              name: "مدیریت شهر‌ها و استان‌ها",
              component: CitiesManagement,
            },
            {
              path: "/admin/mapSettings",
              name: "تنظیمات نقشه",
              component: MapSettings,
            },
            {
              path: "/admin/banners",
              name: "تنظیمات بنرها",
              component: adminBanners,
            },
          ],
        },
      ],
    },
    // head Routes
    {
      path: "/head",
      redirect: "/head/dashboard",
      // meta: { label: 'خانه' },
      // name: 'head_home',
      component: DefaultContainer,
      children: [
        // head Pages
        {
          path: "/head/dashboard",
          name: "ادمین ناظر",
          component: headDashboard,
          children: [
            {
              path: "/head/changelog",
              name: "تغییرات هر نسخه",
              component: ChangeLog,
            },
            {
              path: "/head/proposalCp/:id",
              name: "طرح پژوهشی",
              component: underDevelopment ? ComingSoon : headProposalCp,
            },
            {
              path: "/head/postDocCp/:id",
              name: "پسادکتری ",
              component: underDevelopment ? ComingSoon : headPostDocCp,
            },
            {
              path: "/head/phdProposalCp/:id",
              name: "رساله‌دکتری",
              component: underDevelopment ? ComingSoon : headPhdProposalCp,
            },
            {
              path: "/head/masterProposalCp/:id",
              name: "پایان‌نامه‌ارشد",
              component: underDevelopment ? ComingSoon : headMasterProposalCp,
            },
            {
              path: "/head/opportunityCp/:id",
              name: " فرصت مطالعاتی ",
              component: underDevelopment ? ComingSoon : headOpportunityCp,
            },
            {
              path: "/head/meetingCp/:id",
              name: " نشست تخصصی ",
              component: underDevelopment ? ComingSoon : headMeetingCp,
            },
            {
              path: "/head/eliteCp/:id",
              name: " نخبه وظیفه ",
              component: underDevelopment ? ComingSoon : headEliteCp,
            },
            {
              path: "/head/reports",
              name: "گزارش‌ها",
              component: headReports,
            },
            {
              path: "/head/advancedReport",
              name: "گزارش‌ پیشرفته",
              component: adminReport,
            },
            {
              path: "/head/universityReport",
              name: "گزارش‌ دانشگاه",
              component: adminUniversityReport,
            },
            {
              path: "/head/personalReport",
              name: "گزارش‌ فردی",
              component: adminPersonalReport,
            },
            {
              path: "/head/requestsReport",
              name: "گزارش حمایت ها و محور ها",
              component: adminRequestsReport,
            },
            {
              path: "/head/newPc",
              name: "جدیدها",
              component: headNewPc,
            },
            {
              path: "/head/goingPc",
              name: "در حال انجام‌ها",
              component: headGoingPc,
            },
            {
              path: "/head/archivePc",
              name: "آرشیو",
              component: headArchivePc,
            },
            {
              path: "/head/changepassword",
              name: "تغییر رمز عبور",
              component: headChangePassword,
            },
            {
              path: "/head/activeProposals",
              name: "طرح‌های در دست بررسی",
              component: headActiveProposals,
            },
            {
              path: "/head/proposal/:id",
              name: "شناسنامه طرح",
              component: headProposal,
            },
            {
              path: "/head/decidedProposals",
              name: "طرح‌های تایید شده",
              component: headDecidedProposals,
            },
            {
              path: "/head/needEditProposals",
              name: "طرح‌های نیازمند بازنگری",
              component: headNeedEditProposals,
            },
            {
              path: "/head/canceledProposals",
              name: "طرح‌های رد شده",
              component: headCanceledProposals,
            },
            {
              path: "/head/archive",
              name: "آرشیو طرح‌ها",
              component: headArchive,
            },

            // PhD
            {
              path: "/head/activePhds",
              name: "رساله‌های در دست بررسی",
              component: headActivePhds,
            },
            {
              path: "/head/phdProposal/:id",
              name: "شناسنامه رساله",
              component: headPhdProposal,
            },
            {
              path: "/head/decidedPhds",
              name: "رساله‌های تایید شده",
              component: headDecidedPhds,
            },
            {
              path: "/head/needEditPhds",
              name: "رساله‌های نیازمند بازنگری",
              component: headNeedEditPhds,
            },
            {
              path: "/head/canceledPhds",
              name: "رساله‌های رد شده",
              component: headCanceledPhds,
            },

            // Master
            {
              path: "/head/activeMasters",
              name: "پایان‌نامه‌های در دست بررسی",
              component: headActiveMasters,
            },
            {
              path: "/head/masterProposal/:id",
              name: "شناسنامه پایان‌نامه",
              component: headMasterProposal,
            },
            {
              path: "/head/decidedMasters",
              name: "پایان‌نامه‌های تایید شده",
              component: headDecidedMasters,
            },
            {
              path: "/head/needEditMasters",
              name: "پایان‌نامه‌های نیازمند بازنگری",
              component: headNeedEditMasters,
            },
            {
              path: "/head/canceledMasters",
              name: "پایان‌نامه‌های رد شده",
              component: headCanceledMasters,
            },

            // Article
            {
              path: "/head/activeArticles",
              name: "مقاله‌های در دست بررسی",
              component: headActiveArticles,
            },
            {
              path: "/head/Article/:id",
              name: "شناسنامه مقاله",
              component: headArticle,
            },
            {
              path: "/head/decidedArticles",
              name: "مقاله‌های تایید شده",
              component: headDecidedArticles,
            },
            {
              path: "/head/needEditArticles",
              name: "مقاله‌های نیازمند بازنگری",
              component: headNeedEditArticles,
            },
            {
              path: "/head/canceledArticles",
              name: "مقاله‌های رد شده",
              component: headCanceledArticles,
            },

            // Study Abroad Opportunity
            {
              path: "/head/activeOpportunities",
              name: "فرصت‌‍‌های در دست بررسی",
              component: headActiveOpportunities,
            },
            {
              path: "/head/opportunity/:id",
              name: "شناسنامه فرصت",
              component: headOpportunity,
            },
            {
              path: "/head/decidedOpportunities",
              name: "فرصت‌‍‌های تایید شده",
              component: headDecidedOpportunities,
            },
            {
              path: "/head/needEditOpportunities",
              name: "فرصت‌‍‌های نیازمند بازنگری",
              component: headNeedEditOpportunities,
            },
            {
              path: "/head/canceledOpportunities",
              name: "فرصت‌‍‌های رد شده",
              component: headCanceledOpportunities,
            },

            // Scientific Meeting Report
            {
              path: "/head/activeMeetings",
              name: "نشست‌های در دست بررسی",
              component: headActiveMeetings,
            },
            {
              path: "/head/Meeting/:id",
              name: "شناسنامه نشست",
              component: headMeeting,
            },
            {
              path: "/head/decidedMeetings",
              name: "نشست‌های تایید شده",
              component: headDecidedMeetings,
            },
            {
              path: "/head/needEditMeetings",
              name: "نشست‌های نیازمند بازنگری",
              component: headNeedEditMeetings,
            },
            {
              path: "/head/canceledMeetings",
              name: "نشست‌های رد شده",
              component: headCanceledMeetings,
            },

            // PostDoctorate
            {
              path: "/head/activePostDocs",
              name: "دوره‌های در دست بررسی",
              component: headActivePostDocs,
            },
            {
              path: "/head/PostDoc/:id",
              name: "شناسنامه پسادکتری",
              component: headPostDoc,
            },
            {
              path: "/head/decidedPostDocs",
              name: "دوره‌های تایید شده",
              component: headDecidedPostDocs,
            },
            {
              path: "/head/needEditPostDocs",
              name: "دوره‌های نیازمند بازنگری",
              component: headNeedEditPostDocs,
            },
            {
              path: "/head/canceledPostDocs",
              name: "دوره‌های رد شده",
              component: headCanceledPostDocs,
            },

            // Elite
            {
              path: "/head/activeElites",
              name: "نخبه وظیفه در دست بررسی",
              component: headActiveElites,
            },
            {
              path: "/head/Elite/:id",
              name: "شناسنامه نخبه",
              component: headElite,
            },
            {
              path: "/head/decidedElites",
              name: "نخبه وظیفه تایید شده",
              component: headDecidedElites,
            },
            {
              path: "/head/needEditElites",
              name: "نخبه وظیفه نیازمند بازنگری",
              component: headNeedEditElites,
            },
            {
              path: "/head/canceledElites",
              name: "نخبه وظیفه رد شده",
              component: headCanceledElites,
            },

            {
              path: "/head/users",
              name: "پژوهشگران",
              component: headUsers,
            },
            {
              path: "/head/universities",
              name: "لیست دانشگاه‌ها",
              component: headUniversities,
            },
            {
              path: "/head/topics",
              name: "لیست موضوعات و محورها",
              component: headTopics,
            },
            {
              path: "/head/reviewers",
              name: "داوران",
              component: headReviewers,
            },
            {
              path: "/head/rejectionType",
              name: "دلایل رد درخواست",
              component: headRejectionType,
            },
            {
              path: "/head/guide",
              name: " راهنما ",
              component: guide,
            },
          ],
        },
      ],
    },
    // Company Manager Routes
    {
      path: "/companyManager",
      redirect: "/companyManager/dashboard",
      component: DefaultContainer,
      children: [
        // Company Manager Pages
        {
          path: "/companyManager/dashboard",
          name: "ادمین شرکت‌ها",
          component: companyManagerDashboard,
          children: [
            {
              path: "/companyManager/changelog",
              name: "تغییرات هر نسخه",
              component: ChangeLog,
            },
            {
              path: "/companyManager/companies",
              name: "لیست شرکت‌ها",
              component: companyManagerCompanies,
              children: [
                {
                  path: "/companyManager/company/:id",
                  name: "پروفایل شرکت",
                  component: companyManagerCompany,
                },
                {
                  path: "/companyManager/addCompany",
                  name: "شرکت جدید",
                  component: companyManagerAddCompany,
                },
              ],
            },
            {
              path: "/companyManager/changepassword",
              name: "تغییر رمز عبور",
              component: companyManagerChangePassword,
            },
          ],
        },
      ],
    },
    // University Routes
    {
      path: "/university",
      redirect: "/university/dashboard",
      component: DefaultContainer,
      children: [
        // University Pages
        {
          path: "/university/dashboard",
          name: "دانشگاه",
          component: universityDashboard,
          children: [
            {
              path: "/university/changelog",
              name: "تغییرات هر نسخه",
              component: ChangeLog,
            },
            {
              path: "/university/changePassword",
              name: "تغییر رمز عبور",
              component: universityChangePass,
            },
            {
              path: "/university/proposals",
              name: "طرح‌های دانشگاه",
              component: universityProposals,
            },
            {
              path: "/university/proposal/:id",
              name: "طرح‌ دانشگاه",
              component: universityProposal,
            },

            {
              path: "/university/articles",
              name: "مقالات دانشگاه",
              component: universityArticles,
            },
            {
              path: "/university/article/:id",
              name: "مقاله دانشگاه",
              component: universityArticle,
            },
            {
              path: "/university/elites",
              name: "نخبگان دانشگاه",
              component: universityElites,
            },
            {
              path: "/university/elite/:id",
              name: "نخبه دانشگاه",
              component: universityElite,
            },
            {
              path: "/university/masters",
              name: "پایان‌نامه‌های دانشگاه",
              component: universityMasters,
            },
            {
              path: "/university/master/:id",
              name: "پایان‌نامه دانشگاه",
              component: universityMaster,
            },
            {
              path: "/university/meetings",
              name: "نشست‌های دانشگاه",
              component: universityMeetings,
            },
            {
              path: "/university/meeting/:id",
              name: "نشست دانشگاه",
              component: universityMeeting,
            },
            {
              path: "/university/opportunities",
              name: "فرصت‌های دانشگاه",
              component: universityOpportunities,
            },
            {
              path: "/university/opportunity/:id",
              name: "فرصت دانشگاه",
              component: universityOpportunity,
            },
            {
              path: "/university/phds",
              name: "رساله‌های دانشگاه",
              component: universityPhds,
            },
            {
              path: "/university/phd/:id",
              name: "رساله دانشگاه",
              component: universityPhd,
            },
            {
              path: "/university/postDocs",
              name: "پسادکتری‌های دانشگاه",
              component: universityPostDocs,
            },
            {
              path: "/university/postDoc/:id",
              name: "پسادکتری دانشگاه",
              component: universityPostDoc,
            },
            {
              path: "/university/images",
              name: "گالری تصاویر دانشگاه",
              component: editUniversityImages,
            },
            {
              path: "/university/faculty",
              name: "هیئت علمی دانشگاه",
              component: editUniversityFaculty,
            },
            {
              path: "/university/guide",
              name: "راهنما",
              component: guide,
            },
            {
              path: "/university/preview",
              name: "پیش‌نمایش",
              component: uniPreview,
            },
            {
              path: "/university/complete",
              name: "تکمیل اطلاعات پژوهشی",
              component: uniCompleteCat,
            },
            {
              path: "/university/faq",
              name: "سوالات متداول",
              component: uniFaq,
            },
            {
              path: "/university/newUniRequest",
              name: "ثبت درخواست طرح کلان",
              component: uniNewUniRequest,
            },
            {
              path: "/university/completeUniRequest/:id",
              name: "تکمیل درخواست طرح کلان",
              component: uniCompleteUniRequest,
            },
            {
              path: "/university/activeRequests",
              name: "درخواست‌های طرح کلان فعال",
              component: uniActiveUniRequests,
            },
            {
              path: "/university/inactiveRequests",
              name: "درخواست‌های طرح کلان غیرفعال",
              component: uniInactiveUniRequests,
            },
            {
              path: "/university/uniRequest/:id",
              name: "جزییات درخواست طرح کلان",
              component: uniUniRequest,
            },
          ],
        },
      ],
    },
    // company Routes
    {
      path: "/company",
      redirect: "/company/dashboard",
      component: DefaultContainer,
      children: [
        // company Pages
        {
          path: "/company/dashboard",
          name: "شرکت",
          component: companyDashboard,
          children: [
            {
              path: "/company/changelog",
              name: "تغییرات هر نسخه",
              component: ChangeLog,
            },
            {
              path: "/company/images",
              name: "گالری تصاویر شرکت",
              component: editCompanyImages,
            },
            {
              path: "/company/guide",
              name: "راهنما",
              component: guide,
            },
          ],
        },
      ],
    },
    // accelerator Routes
    {
      path: "/accelerator",
      redirect: "/accelerator/dashboard",
      component: DefaultContainer,
      children: [
        // accelerator Pages
        {
          path: "/accelerator/dashboard",
          name: "شتاب‌دهنده",
          component: acceleratorDashboard,
          children: [
            {
              path: "/accelerator/images",
              name: "گالری تصاویر شتاب‌دهنده",
              component: editAcceleratorImages,
            },
            {
              path: "/accelerator/registeredProposals",
              name: "طرح‌های ثبت شده",
              component: RegisteredProposals,
            },
            {
              path: "/accelerator/registeredPhds",
              name: "رساله‌های ثبت شده",
              component: RegisteredPhds,
            },
            {
              path: "/accelerator/registeredMasters",
              name: "پایان‌نامه‌های ثبت شده",
              component: RegisteredMasters,
            },
            {
              path: "/accelerator/registeredOpportunities",
              name: "فرصت‌های ثبت شده",
              component: RegisteredOpportunity,
            },
            {
              path: "/accelerator/registeredPostDocs",
              name: "پسا دکتری ثبت شده",
              component: RegisteredPostDoc,
            },
            {
              path: "/accelerator/pcReports",
              name: "گزارش‌های کنترل پروژه",
              component: PcReports,
            },
            {
              path: "/accelerator/doneProjectsControl",
              name: "گزارش‌های انجام شده کنترل پروژه",
              component: AcceleratorDoneProjectsControl,
            },

            {
              path: "/accelerator/proposalPc/:id",
              name: "کنترل پروژه طرح پژوهشی",
              component: ProposalPc,
            },
            {
              path: "/accelerator/PostDocPc/:id",
              name: "کنترل پروژه پسا دکتری",
              component: PostDocPc,
            },
            {
              path: "/accelerator/MasterPc/:id",
              name: "کنترل پروژه پایان‌ نامه ارشد",
              component: MasterProposalPc,
            },
            {
              path: "/accelerator/PhdPc/:id",
              name: "کنترل پروژه رساله دکتری",
              component: PhdProposalPc,
            },
            {
              path: "/accelerator/ElitePc/:id",
              name: "کنترل پروژه نخبه وظیفه ",
              component: ElitePc,
            },
            {
              path: "/accelerator/MeetingPc/:id",
              name: "کنترل پروژه نشست تخصصی ",
              component: MeetingPc,
            },
            {
              path: "/accelerator/OpportunityPc/:id",
              name: "کنترل پروژه فرصت مطالعاتی ",
              component: OpportunityPc,
            },
            {
              path: "/accelerator/proposal/:id",
              name: "شناسنامه طرح پژوهشی",
              component: acceleratorProposal,
            },
            {
              path: "/accelerator/PhdProposal/:id",
              name: "شناسنامه رساله دکتری",
              component: acceleratorPhdProposal,
            },
            {
              path: "/accelerator/Article/:id",
              name: "شناسنامه مقاله",
              component: acceleratorArticle,
            },
            {
              path: "/accelerator/MasterProposal/:id",
              name: "شناسنامه کارشناسی ارشد",
              component: acceleratorMasterProposal,
            },

            {
              path: "/accelerator/opportunity/:id",
              name: "شناسنامه فرصت",
              component: acceleratorOpportunity,
            },
            {
              path: "/accelerator/meeting/:id",
              name: "شناسنامه نشست",
              component: acceleratorMeeting,
            },
            {
              path: "/accelerator/postDoc/:id",
              name: "شناسنامه پسادکتری",
              component: acceleratorPostDoc,
            },
            {
              path: "/accelerator/elite/:id",
              name: "شناسنامه نخبه",
              component: acceleratorElite,
            },
            {
              path: "/accelerator/proposalReview/:id",
              name: "داوری طرح",
              component: ProposalReview,
            },
            {
              path: "/accelerator/phdReview/:id",
              name: "داوری رساله",
              component: PhdReview,
            },
            {
              path: "/accelerator/masterReview/:id",
              name: "داوری کارشناسی ارشد",
              component: MasterReview,
            },
            {
              path: "/accelerator/articleReview/:id",
              name: "داوری مقاله",
              component: ArticleReview,
            },
            {
              path: "/accelerator/opportunityReview/:id",
              name: "داوری فرصت",
              component: OpportunityReview,
            },
            {
              path: "/accelerator/meetingReview/:id",
              name: "داوری نشست",
              component: MeetingReview,
            },
            {
              path: "/accelerator/postDocReview/:id",
              name: "داوری پسادکتری",
              component: PostDocReview,
            },
            {
              path: "/accelerator/eliteReview/:id",
              name: "داوری نخبه",
              component: EliteReview,
            },
            {
              path: "/accelerator/allRequests",
              name: "کل حمایت‌ها",
              component: AllRequests,
            },
            {
              path: "/accelerator/waitingForCommercialization",
              name: "حمایت‌های در انتظار تجاری‌سازی",
              component: WaitingForCommercialization,
            },
            {
              path: "/accelerator/reviews",
              name: "حمایت‌های در انتظار داوری",
              component: acceleratorReviews,
            },
            {
              path: "/accelerator/archiveReviews",
              name: "تاریخچه داوری‌ها",
              component: acceleratorArchiveReviews,
            },
            {
              path: "/accelerator/changelog",
              name: "تغییرات هر نسخه",
              component: ChangeLog,
            },
            {
              path: "/accelerator/guide",
              name: "راهنما",
              component: guide,
            },
          ],
        },
      ],
    },
    // Researcher Routes
    {
      path: "/researcher",
      redirect: "/researcher/dashboard",
      // meta: { label: 'خانه' },
      // name: 'researcher_home',
      component: DefaultContainer,
      children: [
        {
          path: "/researcher/changelog",
          name: "تغییرات هر نسخه",
          component: ChangeLog,
        },
        // Researcher Pages
        {
          path: "/researcher/dashboard",
          name: "پژوهشگر",
          component: researcherDashboard,
          children: [
            {
              path: "/researcher/activeArticle",
              name: "مقالات فعال",
              component: ActiveArticle,
              children: [
                {
                  path: "/researcher/newArticle",
                  name: "مقاله جدید",
                  // component: NewArticle
                  component: NewArticle,
                },
                {
                  path: "/researcher/Article/:id",
                  name: "مقاله",
                  component: ViewArticle,
                },
                {
                  path: "/researcher/completeArticle/:id",
                  name: "حمایت از مقاله",
                  component: CompleteArticle,
                },
              ],
            },
            {
              path: "/researcher/deactiveArticle",
              name: "مقالات غیر‌فعال",
              component: DeactiveArticle,
            },
            {
              path: "/researcher/decidedArticle",
              name: "مقالات تعیین تکلیف شده",
              component: DecidedArticle,
            },
            {
              path: "/researcher/eliteCp/:id",
              name: "نخبه وظیفه ",
              component: underDevelopment ? ComingSoon : researcherEliteCp,
            },

            {
              path: "/researcher/ActiveElite",
              name: "حمایت‌های نخبگان فعال",
              component: ActiveElite,
              children: [
                {
                  path: "/researcher/newElite",
                  name: "نخبه وظیفه جدید",
                  component: NewElite,
                },
                {
                  path: "/researcher/elite/:id",
                  name: "نخبه وظیفه",
                  component: ViewElite,
                },
                {
                  path: "/researcher/completeElite/:id",
                  name: "حمایت از نخبگان",
                  component: CompleteElite,
                },
              ],
            },
            {
              path: "/researcher/DeactiveElite",
              name: "حمایت‌های نخبگان غیرفعال",
              component: DeactiveElite,
            },
            {
              path: "/researcher/DecidedElite",
              name: "حمایت‌های تعیین تکلیف شده ",
              component: DecidedElite,
            },
            {
              path: "/researcher/postDocCp/:id",
              name: " پسادکتری",
              component: underDevelopment ? ComingSoon : researcherPostDocCp,
            },

            {
              path: "/researcher/activePostDoc",
              name: "دوره‌های پسادکتری فعال",
              component: ActivePostDoc,
              children: [
                {
                  path: "/researcher/postDoc/:id",
                  name: "پسادکتری",
                  component: ViewPostDoc,
                },
                {
                  path: "/researcher/newPostDoc",
                  name: "پسادکتری جدید",
                  component: NewPostDoc,
                },
                {
                  path: "/researcher/completePostDoc/:id",
                  name: "حمایت از پسادکتری",
                  component: CompletePostDoc,
                },
              ],
            },
            {
              path: "/researcher/deactivePostDoc",
              name: "دوره‌های پسادکتری غیرفعال",
              component: DeactivePostDoc,
            },
            {
              path: "/researcher/decidedPostDoc",
              name: "دوره‌های تعیین تکلیف شده",
              component: DecidedPostDoc,
            },

            {
              path: "/researcher/meetingCp/:id",
              name: "نشست تخصصی ",
              component: underDevelopment ? ComingSoon : researcherMeetingCp,
            },
            {
              path: "/researcher/completeMeeting/:id",
              name: "حمایت از نشست های تخصصی ",
              component: CompleteMeeting,
            },
            {
              path: "/researcher/activeMeeting",
              name: "نشست های تخصصی فعال",
              component: ActiveMeeting,
              children: [
                {
                  path: "/researcher/meeting/:id",
                  name: "نشست تخصصی",
                  component: ViewMeeting,
                },
                {
                  path: "/researcher/newMeeting",
                  name: "نشست تخصصی جدید",
                  component: NewMeeting,
                },
                {
                  path: "/researcher/completeMeeting/:id",
                  name: "حمایت از نشست های تخصصی",
                  component: CompleteMeeting,
                },
              ],
            },
            {
              path: "/researcher/deactiveMeeting",
              name: "نشست های تخصصی غیرفعال",
              component: DeactiveMeeting,
            },
            {
              path: "/researcher/decidedMeeting",
              name: "نشست های تخصصی تعیین تکلیف شده",
              component: DecidedMeeting,
            },
            {
              path: "/researcher/opportunityCp/:id",
              name: "فرصت مطالعاتی ",
              component: underDevelopment
                ? ComingSoon
                : researcherOpportunityCp,
            },

            {
              path: "/researcher/activeOpportunity",
              name: "فرصت مطالعاتی فعال",
              component: ActiveOpportunity,
              children: [
                {
                  path: "/researcher/newOpportunity",
                  name: "فرصت مطالعاتی جدید",
                  component: NewOpportunity,
                },
                {
                  path: "/researcher/opportunity/:id",
                  name: "فرصت مطالعاتی",
                  component: ViewOpportunity,
                },
                {
                  path: "/researcher/completeOpportunity/:id",
                  name: "حمایت از فرصت مطالعاتی",
                  component: CompleteOpportunity,
                },
              ],
            },
            {
              path: "/researcher/deactiveOpportunity",
              name: "فرصت مطالعاتی غیرفعال",
              component: DeactiveOpportunity,
            },
            {
              path: "/researcher/decidedOpportunity",
              name: "فرصت مطالعاتی تعیین تکلیف شده",
              component: DecidedOpportunity,
            },
            {
              path: "/researcher/profile",
              name: " حساب کاربری",
              component: researcherProfile,
            },
            {
              path: "/researcher/newPc",
              name: "جدیدها ",
              component: researcherNewPc,
            },
            {
              path: "/researcher/goingPc",
              name: "در حال انجام‌ها ",
              component: researcherGoingPc,
            },
            {
              path: "/researcher/archivePc",
              name: "آرشیو ",
              component: researcherArchivePc,
            },
            {
              path: "/researcher/proposalCp/:id",
              name: "طرح پژوهشی ",
              component: underDevelopment ? ComingSoon : researcherProposalCp,
            },
            {
              path: "/researcher/proposals",
              name: "طرح‌ها",
              component: researcherProposals,
            },
            {
              path: "/researcher/activeUnirequests",
              name: "فعال",
              component: researcherActiveUniRequests,
            },
            {
              path: "/researcher/deactiveUnirequests",
              name: "غیرفعال",
              component: researcherInactiveUniRequests,
            },
            {
              path: "/researcher/unirequest/:id",
              name: "جزییات درخواست",
              component: researcherUniRequestInfo,
            },
            {
              path: "/researcher/editunirequest/:id",
              name: "ویرایش درخواست",
              component: researcherEditUniRequest,
            },
            {
              path: "/researcher/activeProposals",
              name: "طرح‌ها فعال",
              component: researcherActiveProposals,
              children: [
                {
                  path: "/researcher/newProposal",
                  name: "طرح جدید",
                  component: newProposal,
                },
                {
                  path: "/researcher/completeProposal/:id",
                  name: "تکمیل طرح",
                  component: completeProposal,
                },
                {
                  path: "/researcher/sampleRepeatable",
                  name: "ویرایش طرح",
                  component: sampleRepeatable,
                },
                {
                  path: "/researcher/proposal/:id",
                  name: "مشاهده طرح",
                  component: viewProposal,
                },
              ],
            },
            {
              path: "/researcher/deactiveProposals",
              name: "طرح‌های غیرفعال",
              component: researcherDeactiveProposals,
            },
            {
              path: "/researcher/decidedProposals",
              name: "طرح‌ها تعیین تکلیف شده",
              component: researcherDecidedProposals,
            },
            {
              path: "/researcher/phdProposalCp/:id",
              name: "رساله دکتری ",
              component: underDevelopment
                ? ComingSoon
                : researcherPhdProposalCp,
            },
            {
              path: "/researcher/phdThesis",
              name: "رساله دکتری",
              component: phdThesis,
            },
            {
              path: "/researcher/activePhdThesis",
              name: "رساله‌های فعال",
              component: researcherActivePhdThesis,
              children: [
                {
                  path: "/researcher/newPhdThesis",
                  name: "تعریف رساله دکتری جدید",
                  component: NewPhdThesis,
                },
                {
                  path: "/researcher/completePhdThesis/:id",
                  name: "تکمیل رساله دکتری",
                  component: completePhdThesis,
                },
                {
                  path: "/researcher/phdProposal/:id",
                  name: "مشاهده رساله دکتری",
                  component: viewPhdProposal,
                },
              ],
            },
            {
              path: "/researcher/deactivePhdThesis",
              name: "رساله‌های غیرفعال",
              component: researcherDeactivePhdThesis,
            },
            {
              path: "/researcher/decidedPhdThesis",
              name: "رساله‌های تعیین تکلیف شده",
              component: researcherDecidedPhdThesis,
            },
            {
              path: "/researcher/masterProposalCp/:id",
              name: "پایان‌نامه کارشناسی‌ارشد ",
              component: underDevelopment
                ? ComingSoon
                : researcherMasterProposalCp,
            },
            {
              path: "/researcher/masterThesis",
              name: "پایان‌نامه کارشناسی‌ارشد",
              component: masterThesis,
            },
            {
              path: "/researcher/activeMasterThesis",
              name: "پایان‌نامه‌های ارشد فعال",
              component: researcherActiveMasterThesis,
              children: [
                {
                  path: "/researcher/newMasterThesis",
                  name: "تعریف پایان‌نامه ارشد جدید",
                  component: newMasterThesis,
                },
                {
                  path: "/researcher/completeMasterThesis/:id",
                  name: "تکمیل پایان‌نامه ارشد",
                  component: completeMasterThesis,
                },
                {
                  path: "/researcher/masterProposal/:id",
                  name: "مشاهده پایان‌نامه ارشد",
                  component: viewMasterProposal,
                },
              ],
            },
            {
              path: "/researcher/deactiveMasterThesis",
              name: "پایان‌نامه‌های ارشد غیرفعال",
              component: researcherDeactiveMasterThesis,
            },
            {
              path: "/researcher/decidedMasterThesis",
              name: "پایان‌نامه‌های ارشد تعیین تکلیف شده",
              component: researcherDecidedMasterThesis,
            },

            {
              path: "/researcher/newRequest",
              name: "درخواست جدید",
              component: newRequest,
            },
            {
              path: "/researcher/newUniRequestForm/",
              name: "درخواست جدید",
              component: newUniRequestForm,
            },
            // {
            //   path: "/newRequestForm",
            //   name: "درخواست جدید",
            //   component: newRequestForm,
            // },
            { path: "/researcher/debug", name: "گزارش خطا", component: Debug },
            {
              path: "/researcher/guide",
              name: "راهنما",
              component: guide,
            },
          ],
        },
      ],
    },
    { path: "/", redirect: localStorage.role ? localStorage.role : "/login" },
    { path: "*", component: Page404 },
    { path: "/unauthorize", component: Page403 },
    { path: "/comingSoon", component: SystemComingSoon },
    {
      path: "/login",
      name: "Login",
      component: Login,
    },
    {
      path: "/Map",
      name: "Map",
      component: Map,
    },
    {
      path: "/UniversityProfile/:id",
      name: "University Profile",
      component: UniversityProfile,
    },
    {
      path: "/universityFaculty/:id",
      name: "University Faculty Members",
      component: UniversityFacultyMembers,
    },
    {
      path: "/universityImages/:id",
      name: "University Images",
      component: UniversityImages,
    },
    {
      path: "/CompanyProfile/:id",
      name: "Company Profile",
      component: CompanyProfile,
    },
    {
      path: "/companyImages/:id",
      name: "Company Images",
      component: CompanyImages,
    },
    {
      path: "/acceleratorProfile/:id",
      name: "Accelerator Profile",
      component: AcceleratorProfile,
    },
    {
      path: "/researcherProfile/:id",
      name: "Researcher Profile",
      component: mapResearcherProfile,
    },
    {
      path: "/acceleratorImages/:id",
      name: "Accelerator Images",
      component: AcceleratorImages,
    },
    {
      path: "/adminLogin",
      name: "AdminLogin",
      component: AdminLogin,
    },
    {
      path: "/refLogin",
      name: "RefLogin",
      component: RefLogin,
    },
    {
      path: "/uniLogin",
      name: "UniLogin",
      component: UniLogin,
    },
    {
      path: "/CompanyLogin",
      name: "CompanyLogin",
      component: CompanyLogin,
    },
    {
      path: "/acceleratorLogin",
      name: "AcceleratorLogin",
      component: AcceleratorLogin,
    },
    // NOTE login for delveloping cause captcha doesnt work in locak
    {
      path: "/loginSolid",
      name: "LoginSolid",
      component: LoginSolid,
    },
    {
      path: "/adminLoginSolid",
      name: "AdminLoginSolid",
      component: AdminLoginSolid,
    },
    {
      path: "/refLoginSolid",
      name: "RefLoginSolid",
      component: RefLoginSolid,
    },
    {
      path: "/uniLoginSolid",
      name: "UniLoginSolid",
      component: UniLoginSolid,
    },
    {
      path: "/CompanyLoginSolid",
      name: "CompanyLoginSolid",
      component: CompanyLoginSolid,
    },
    {
      path: "/acceleratorLoginSolid",
      name: "AcceleratorLoginSolid",
      component: AcceleratorLoginSolid,
    },
  ],
});
